export const readFileAsDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Failed to read image file."));
    reader.readAsDataURL(file);
  });

export const isValidImageUrl = (value) =>
  /^https?:\/\/.+/i.test(String(value || "").trim());

export const normalizeImageList = (firstImage, secondImage) => {
  const images = [firstImage, secondImage].filter(Boolean);

  if (!images.length) {
    return [{ id: "1", value: "./assets/blog/blogsIOT.png" }];
  }

  return images.map((value, index) => ({
    id: String(index + 1),
    value,
  }));
};
